<template>
    <div v-if="isreadshow">
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="提交人" prop="addusername" min-width="50" fixed></el-table-column>
            <el-table-column label="问题标题" prop="yqcqwttitle" min-width="50"></el-table-column>
            <el-table-column label="提交时间" prop="yqtjtime" width="200"></el-table-column>
            <el-table-column label="提交单位" prop="tjdwname" width="180"></el-table-column>
            <el-table-column label="状态" width="180">
                <template slot-scope="scope">
                    <my-tag type="danger" v-if="scope.row.exthfbj===null||scope.row.exthfbj==='0'">未回复</my-tag>
                    <my-tag type="success" v-else>已回复</my-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right">
                <template slot-scope="scope">
                    <my-btn type="detail" @click="detail(scope.row.wtcode)">详情</my-btn>
                    <my-btn type="edit" @click="lookfile('0',scope.row)">查看专家提问附件</my-btn>
                    <my-btn type="edit" @click="lookfile('1',scope.row)">查看投标人回复附件</my-btn>  
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('bidUrl')}/ckzjzy/getcqlist.json`"></my-pagination>
           <my-dialog 
        v-model="dialogVisible"
        :title="form.title"
        width="1000px"
        >
            <tiwen :form="form"
                v-if="dialogVisible"
                @cancle="dialogClose"
            ></tiwen>
        </my-dialog>  
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import tiwen from './sub-pages/tiwen'
export default {
    components: { tiwen },
    mixins: [LIST_PAGE_MIXIN, FORM_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    data() {
        return{
            pgData:{
                bdcode:'',
                sortname : 'wtcode',       
            },
            form:{
                title:''
            },
            isreadshow:true,
            tableData:[]
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        //刷新
        reload:function(){
            var that = this;
            this.isreadshow=false;
            this.$nextTick(function(){
                that.isreadshow=true;
            })
        },
        //详情
        detail:function(id){
            this.goto({
                path:'./hfdetail',
                query:{
                    id:id
                }
            });
        },
        //查看附件
        lookfile:function(code,row){
            this.editHandler(row)
            if(code==='0') {
                this.form.title='查看专家提问附件'
            }
            if(code==='1') {
                this.form.title='查看投标人回复附件'
            }
         
        },
        
    },
    created() {
        if(this.getQuery('bdcode')!==undefined){
            this.pgData.bdcode=this.getQuery('bdcode')
        }
       
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
